import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../utils/getDomainData";

const OTPRI_AboutUs = () => {
    const [data, setData] = useState([]);
    let location = useLocation();
    const currentDomain = location.pathname.split("/")[1];
    const { fontSize } = useFontSize();

    useEffect(() => {
        fetchData(getAPIPath(currentDomain)?.aboutUs, setData);
    }, [currentDomain]);

    // Function to render rich text content
    const renderRichText = (content) => {
        if (!content || !Array.isArray(content)) return null;
        
        return content.map((block, index) => {
            if (block.type === 'paragraph') {
                return (
                    <p key={index} className="mb-3">
                        {block.children?.map((child, childIndex) => {
                            if (child.type === 'text') {
                                let text = child.text;
                                
                                // Apply formatting
                                if (child.bold) {
                                    text = <strong key={childIndex}>{text}</strong>;
                                }
                                if (child.italic) {
                                    text = <em key={childIndex}>{text}</em>;
                                }
                                if (child.underline) {
                                    text = <u key={childIndex}>{text}</u>;
                                }
                                
                                return text;
                            }
                            return child.text || "";
                        })}
                    </p>
                );
            } else if (block.type === 'list') {
                const ListTag = block.format === 'ordered' ? 'ol' : 'ul';
                
                return (
                    <ListTag key={index} className="features-list">
                        {block.children?.map((listItem, itemIndex) => {
                            if (listItem.type === 'list-item') {
                                return (
                                    <li key={itemIndex}>
                                        {listItem.children?.map((child, childIndex) => {
                                            if (child.type === 'text') {
                                                let text = child.text;
                                                
                                                // Apply formatting
                                                if (child.bold) {
                                                    text = <strong key={childIndex}>{text}</strong>;
                                                }
                                                if (child.italic) {
                                                    text = <em key={childIndex}>{text}</em>;
                                                }
                                                if (child.underline) {
                                                    text = <u key={childIndex}>{text}</u>;
                                                }
                                                
                                                return text;
                                            }
                                            return child.text || "";
                                        })}
                                    </li>
                                );
                            }
                            return null;
                        })}
                    </ListTag>
                );
            }
            return null;
        });
    };

    const aboutData = data?.data?.attributes;

    return (
        <React.Fragment>
            <Helmet>
                <title>About Us | Oil Technological & Pharmaceutical Research Institute | JNTU Anantapur</title>
                <meta
                    name="description"
                    content="About JNTUA Oil Technological and Pharmaceutical Research Institute (OT&PRI) - Learn about our college, features, and educational excellence."
                />
                <meta
                    name="keywords"
                    content="OTPRI About Us, Oil Technological, Pharmaceutical Research Institute, JNTUA, College Information"
                ></meta>
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="home"
                TopBar="enable"
                TopBarClass="topbar-area dark-primary-bg hidden-lg"
            />
            <style>
                {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                    .about-section {
                        background: #f8f9fa;
                        padding: 40px 0;
                    }
                    .college-section {
                        background: #fff;
                        padding: 50px 0;
                    }
                    .features-section {
                        padding: 50px 0;
                    }
                    .section-heading {
                        color: #007bff;
                        font-weight: bold;
                        margin-bottom: 30px;
                        border-bottom: 3px solid #007bff;
                        padding-bottom: 10px;
                        display: inline-block;
                    }
                    .college-intro {
                        font-size: 1.1rem;
                        line-height: 1.8;
                        margin-bottom: 30px;
                        color: #333;
                    }
                    .college-list {
                        list-style: none;
                        padding: 0;
                    }
                    .college-list li {
                        background: #fff;
                        padding: 20px 20px 20px 50px;
                        margin-bottom: 15px;
                        border-radius: 8px;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                        border-left: 4px solid #007bff;
                        position: relative;
                    }
                    .college-list li::before {
                        content: "✓";
                        position: absolute;
                        left: 10px;
                        top: 20px;
                        background: #007bff;
                        color: white;
                        width: 24px;
                        height: 24px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 14px;
                        font-weight: bold;
                    }
                    .college-list li:nth-child(2n) {
                        border-left-color: #28a745;
                    }
                    .college-list li:nth-child(2n)::before {
                        background: #28a745;
                    }
                    .college-list li:nth-child(3n) {
                        border-left-color: #dc3545;
                    }
                    .college-list li:nth-child(3n)::before {
                        background: #dc3545;
                    }
                    .features-list {
                        list-style: none;
                        padding: 0;
                        margin-top: 30px;
                    }
                    .features-list li {
                        background: #fff;
                        padding: 20px;
                        margin-bottom: 15px;
                        border-radius: 8px;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                        border-left: 4px solid #007bff;
                        position: relative;
                        transition: transform 0.3s ease, box-shadow 0.3s ease;
                    }
                    .features-list li:hover {
                        transform: translateX(5px);
                        box-shadow: 0 5px 15px rgba(0,0,0,0.15);
                    }
                    .features-list li:nth-child(2n) {
                        border-left-color: #28a745;
                    }
                    .features-list li:nth-child(3n) {
                        border-left-color: #ffc107;
                    }
                    .about-image {
                        border-radius: 15px;
                        overflow: hidden;
                        box-shadow: 0 10px 30px rgba(0,0,0,0.2);
                        transition: transform 0.3s ease;
                    }
                    .about-image:hover {
                        transform: scale(1.02);
                    }
                    .about-image img {
                        width: 100%;
                        height: auto;
                        display: block;
                    }
                `}
            </style>
            <div className="pageTopOffset">
                {/* breadcrumb-area-start */}
                <SiteBreadcrumb
                    pageTitle="About Us"
                    pageName="About Us"
                    breadcrumbsClass="breadcrumb-bg"
                />
                {/* breadcrumb-area-start */}
                {getMenu(currentDomain)}
                
                <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
                    <div className="container">
                        <div className="row">
                            <div className="col pl-20 md-pl-14">
                                <div className="row">
                                    <div className="rs-inner-blog col-lg-12">
                                        {/* Page Title */}
                                        <h3 className="college-title text-center mb-5">
                                            {aboutData?.title || "About Us"}
                                        </h3>

                                        {/* College Section */}
                                        {aboutData?.collegeSectionHeading && (
                                            <div className="college-section">
                                                <div className="row align-items-center">
                                                    <div className="col-lg-8 col-md-12">
                                                        <h2 className="section-heading">
                                                            {aboutData.collegeSectionHeading}
                                                        </h2>
                                                        
                                                        {/* College Introduction */}
                                                        {aboutData?.collegeIntro && (
                                                            <div className="college-intro">
                                                                {renderRichText(aboutData.collegeIntro)}
                                                            </div>
                                                        )}

                                                        {/* College List */}
                                                        {aboutData?.collegeList && aboutData.collegeList.length > 0 && (
                                                            <ul className="college-list">
                                                                {aboutData.collegeList.map((item, index) => (
                                                                    <li key={item.id || index}>
                                                                        {renderRichText(item.content)}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </div>
                                                    
                                                    {/* About Image */}
                                                    <div className="col-lg-4 col-md-12">
                                                        {aboutData?.image?.data && (
                                                            <div className="about-image">
                                                                <img
                                                                    src={`${imageBaseURL}${aboutData.image.data.attributes.url}`}
                                                                    alt={aboutData.image.data.attributes.alternativeText || "About OTPRI"}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Features Section */}
                                        {aboutData?.featuresSectionHeading && aboutData?.features && (
                                            <div className="features-section">
                                                <h2 className="section-heading text-center">
                                                    {aboutData.featuresSectionHeading}
                                                </h2>
                                                
                                                <div className="features-content">
                                                    {renderRichText(aboutData.features)}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Accreditation />

            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />

            {/* scrolltop-start */}
            <ScrollToTop scrollClassName="scrollup orange-color" />
            {/* scrolltop-end */}

            <SearchModal />
        </React.Fragment>
    );
};

export default OTPRI_AboutUs;